import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { SxCookieService } from 'app/services/sx-cookie.service';
import { Router } from '@angular/router';
import * as sxUtil from '@utils/sx-utilities';
import { CookieAttributes } from 'es-cookie/src/CookieAttributes';
import { UserType } from '@enums';
import { SxAccountRepairService } from 'app/services/sx-account-repair.service';

@Component({
    selector: 'app-register-customer-dialog',
    templateUrl: './session-expired-dialog.html',
    standalone: false
})
export class SessionExpiredDialogComponent implements OnInit {
  constructor(
    private translate: TranslateService,
    private sxCookieService: SxCookieService,
    private accountRepairService: SxAccountRepairService,
    private router: Router,
    public dialogRef: MatDialogRef<SessionExpiredDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  isRepairing = false;
  isSessionReloaded = false;
  sxReloadedSession: string;

  ngOnInit() {
    this.sxReloadedSession = this.sxCookieService.getCookie('SX_RELOADED_SESSION');
    if (this.sxReloadedSession && this.sxReloadedSession === '1') {
      this.isSessionReloaded = true;
    }
  }

  reloadSession = (): void => {
    let userType = this.sxCookieService.getCookie('SX_LOGGED_IN_AS') as UserType;
    this.setDeeplinkCookie(this.router.url);
    this.setReloadedSessionCookie();
    this.router.navigate(['/login/auto/' + sxUtil.getClientIdFromUserType(userType)]);
  };

  private setDeeplinkCookie(deeplink: string) {
    let expiration = new Date();
    expiration.setMinutes(new Date().getMinutes() + 5);
    this.sxCookieService.setCookie('SX_DEEPLINK', deeplink, { expires: expiration } as CookieAttributes);
  }

  private setReloadedSessionCookie = () => {
    let expiration = new Date();
    expiration.setMinutes(new Date().getMinutes() + 5);

    this.sxCookieService.setCookie('SX_RELOADED_SESSION', 1, {
      expires: expiration
    } as CookieAttributes);
  };

  repairAccount = () => {
    this.isRepairing = true;
    this.sxCookieService.clearCookie('SX_RELOADED_SESSION');
    this.accountRepairService.repairAccount().subscribe(_ => this.reloadSessionAfterRepair());
  };

  reloadSessionAfterRepair = (): void => {
    let userType = this.sxCookieService.getCookie('SX_LOGGED_IN_AS') as UserType;
    this.setDeeplinkCookie(this.router.url);
    this.router.navigate(['/login/auto/' + sxUtil.getClientIdFromUserType(userType)]);
  };
}
